import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import axios from "axios";
import {
  READ_RECORD,
  RECORD_STATE,
  POST_RECORD,
  MENU,
  USER,
  GET_RECORD_PARAMETERS,
  SELECT_USER,
  SEARCH_DATA,
  READ_RECORD_FULL,
  MENU_DATA,
  FOLLOW_LIST,
  FOLLOW_LIST_DATA,
  FAVORITE_MENU_DATA,
  FAVORITE_MENU,
  GET_LAST_RECORD_PARAMETERS,
  TIME_RECORD_DATA,
  POST_TIME_RECORD_PARAMETERS,
  TIME_RECORD,
  GET_DATE_RECORD_PARAMETERS,
  DELETE_TIME_RECORD_PARAMETERS,
  UPDATE_TIME_RECORD_PARAMETERS,
  ORIGINAL_MENU_DATA,
  ORIGINAL_MENU,
  POST_ORIGINAL_RECORD,
  ORIGINAL_RECORD,
  ORIGINAL_RECORD_DATA,
  SELECT_MENU_CATEGORY,
} from "../../types/types";

//特定ユーザの特定月のレコード一覧取得
export const fetchAsyncGetRecords = createAsyncThunk(
  "home/getRecords",
  async (para: GET_RECORD_PARAMETERS) => {
    const res = await axios.get<READ_RECORD_FULL>(
      `${process.env.REACT_APP_API_URL}/api-data/records/?user_id=${para.user_id}&date_after=${para.date_after}&date_before=${para.date_before}`,
      {
        headers: {
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );

    return res.data.results;
  }
);
//特定ユーザの特定月のオリジナルメニューレコード一覧取得
export const fetchAsyncGetOriginalRecords = createAsyncThunk(
  "home/getOriginalRecords",
  async (para: GET_RECORD_PARAMETERS) => {
    const res = await axios.get<ORIGINAL_RECORD_DATA>(
      `${process.env.REACT_APP_API_URL}/api-data/original_menu_records/?user_id=${para.user_id}&date_after=${para.date_after}&date_before=${para.date_before}`,
      {
        headers: {
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );

    return res.data.results;
  }
);
//対象ユーザのtempレコードを取得
export const fetchAsyncGetTempRecords = createAsyncThunk(
  "home/getTempRecord",
  async (para: GET_DATE_RECORD_PARAMETERS) => {
    const res = await axios.get<READ_RECORD_FULL>(
      `${process.env.REACT_APP_API_URL}/api-data/temp_records/?user_id=${para.user_id}&date_after=${para.date}&date_before=${para.date}`,
      {
        headers: {
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data.results;
  }
);
//対象ユーザのオリジナルメニューのtempレコードを取得
export const fetchAsyncGetTempOriginalRecords = createAsyncThunk(
  "home/getTempOriginalRecord",
  async (para: GET_DATE_RECORD_PARAMETERS) => {
    const res = await axios.get<ORIGINAL_RECORD_DATA>(
      `${process.env.REACT_APP_API_URL}/api-data/temp_original_records/?user_id=${para.user_id}&date_after=${para.date}&date_before=${para.date}`,
      {
        headers: {
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data.results;
  }
);
//対象ユーザのtempレコードを削除
export const fetchAsyncDeleteTempRecord = createAsyncThunk(
  "home/deleteTempRecord",
  async (id: number) => {
    await axios.delete<number>(
      `${process.env.REACT_APP_API_URL}/api-data/temp_records/${id}/`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return id;
  }
);
//対象ユーザのオリジナルメニューのtempレコードを削除
export const fetchAsyncDeleteTempOriginalRecord = createAsyncThunk(
  "home/deleteTempOriginalRecord",
  async (id: number) => {
    await axios.delete<number>(
      `${process.env.REACT_APP_API_URL}/api-data/temp_original_records/${id}/`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return id;
  }
);
//tempレコード新規作成
export const fetchAsyncCreateTempRecord = createAsyncThunk(
  "home/createTempRecord",
  async (record: POST_RECORD) => {
    const res = await axios.post<READ_RECORD>(
      `${process.env.REACT_APP_API_URL}/api-data/temp_records/`,
      record,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data;
  }
);
//オリジナルメニューにてtempレコード新規作成
export const fetchAsyncCreateTempOriginalRecord = createAsyncThunk(
  "home/createTempOriginalRecord",
  async (record: POST_ORIGINAL_RECORD) => {
    const res = await axios.post<ORIGINAL_RECORD>(
      `${process.env.REACT_APP_API_URL}/api-data/temp_original_records/`,
      record,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data;
  }
);
//tempレコード更新
export const fetchAsyncUpdateTempRecord = createAsyncThunk(
  "home/updateTempRecord",
  async (record: POST_RECORD) => {
    const res = await axios.put<READ_RECORD>(
      `${process.env.REACT_APP_API_URL}/api-data/temp_records/${record.id}/`,
      record,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data;
  }
);
//オリジナルメニューにてtempレコード更新
export const fetchAsyncUpdateTempOriginalRecord = createAsyncThunk(
  "home/updateTempOriginalRecord",
  async (record: POST_ORIGINAL_RECORD) => {
    const res = await axios.put<ORIGINAL_RECORD>(
      `${process.env.REACT_APP_API_URL}/api-data/temp_original_records/${record.id}/`,
      record,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data;
  }
);

// //特定ユーザの特定日のレコード一覧取得
// export const fetchAsyncGetDayRecords = createAsyncThunk(
//   "home/getRecord",
//   async (para: GET_RECORD_PARAMETERS) => {
//     const res = await axios.get<READ_RECORD[]>(
//       `${process.env.REACT_APP_API_URL}/api-data/records/?user_id=${para.user_id}&date_after=${para.date_after}&date_before=${para.date_before}`,
//       {
//         headers: {
//           Authorization: `JWT ${localStorage.localJWT}`,
//         },
//       }
//     );
//     return res.data;
//   }
// );

//ユーザ一覧取得
export const fetchAsyncGetUsers = createAsyncThunk(
  "home/getUsers",
  async (searchWord: string) => {
    const res = await axios.get<USER[]>(
      `${process.env.REACT_APP_API_URL}/api-data/users/?username=${searchWord}`,
      {
        headers: {
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data;
  }
);
//メニュー覧取得
export const fetchAsyncGetMenu = createAsyncThunk(
  "home/getMenu",
  async (part: string) => {
    const res = await axios.get<MENU_DATA>(
      `${process.env.REACT_APP_API_URL}/api-data/menu/?part=${part}`,
      {
        headers: {
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data.results;
  }
);
//特定のメニュー取得
export const fetchAsyncGetTargetMenu = createAsyncThunk(
  "home/getTargetMenu",
  async (id: number) => {
    const res = await axios.get<MENU>(
      `${process.env.REACT_APP_API_URL}/api-data/menu/${id}/`,
      {
        headers: {
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data;
  }
);
//特定のオリジナルメニュー取得
export const fetchAsyncGetTargetOriginalMenu = createAsyncThunk(
  "home/getTargetOriginalMenu",
  async (id: number) => {
    const res = await axios.get<MENU>(
      `${process.env.REACT_APP_API_URL}/api-data/original_menu/${id}/`,
      {
        headers: {
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data;
  }
);
//ログインユーザのお気に入りメニュー取得
export const fetchAsyncGetFavoriteMenu = createAsyncThunk(
  "home/getFavoriteMenu",
  async () => {
    const res = await axios.get<FAVORITE_MENU_DATA>(
      `${process.env.REACT_APP_API_URL}/api-data/favorite_menu/`,
      {
        headers: {
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data.results;
  }
);
//ログインユーザメニューお気に入り登録
export const fetchAsyncCreateFavoriteMenu = createAsyncThunk(
  "home/createFavoriteMenu",
  async (id: number) => {
    const res = await axios.post<FAVORITE_MENU>(
      `${process.env.REACT_APP_API_URL}/api-data/favorite_menu/`,
      { menu_id: id },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data;
  }
);
//お気に入り削除
export const fetchAsyncDeleteFavoriteMenu = createAsyncThunk(
  "home/deleteFavoriteMenu",
  async (id: number) => {
    await axios.delete<number>(
      `${process.env.REACT_APP_API_URL}/api-data/favorite_menu/${id}/`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return id;
  }
);

//レコード新規作成
export const fetchAsyncCreateRecord = createAsyncThunk(
  "home/createRecord",
  async (record: POST_RECORD) => {
    const res = await axios.post<READ_RECORD>(
      `${process.env.REACT_APP_API_URL}/api-data/records/`,
      record,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data;
  }
);
//レコード新規作成
export const fetchAsyncCreateOriginalRecord = createAsyncThunk(
  "home/createOriginalRecord",
  async (record: POST_RECORD) => {
    const res = await axios.post<ORIGINAL_RECORD>(
      `${process.env.REACT_APP_API_URL}/api-data/original_menu_records/`,
      record,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data;
  }
);
//レコード更新
export const fetchAsyncUpdateRecord = createAsyncThunk(
  "home/updateRecord",
  async (record: POST_RECORD) => {
    const res = await axios.put<READ_RECORD>(
      `${process.env.REACT_APP_API_URL}/api-data/records/${record.id}/`,
      record,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data;
  }
);
//オリジナルメニューのレコード更新
export const fetchAsyncUpdateOriginalRecord = createAsyncThunk(
  "home/updateOriginalRecord",
  async (record: ORIGINAL_RECORD) => {
    const res = await axios.put<ORIGINAL_RECORD>(
      `${process.env.REACT_APP_API_URL}/api-data/original_menu_records/${record.id}/`,
      record,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data;
  }
);

//レコード削除
export const fetchAsyncDeleteRecord = createAsyncThunk(
  "home/deleteRecord",
  async (id: number) => {
    await axios.delete<READ_RECORD>(
      `${process.env.REACT_APP_API_URL}/api-data/records/${id}/`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return id;
  }
);
//オリジナルメニューのレコード削除
export const fetchAsyncDeleteOriginalRecord = createAsyncThunk(
  "home/deleteOriginalRecord",
  async (id: number) => {
    await axios.delete<ORIGINAL_RECORD>(
      `${process.env.REACT_APP_API_URL}/api-data/original_menu_records/${id}/`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return id;
  }
);
//前回のレコードを取得
export const fetchAsyncGetLastRecord = createAsyncThunk(
  "home/getLastRecord",
  async (para: GET_LAST_RECORD_PARAMETERS) => {
    const res = await axios.get<READ_RECORD_FULL>(
      `${process.env.REACT_APP_API_URL}/api-data/last_records/?id=${para.id}&menu_id=${para.menu_id}`,
      {
        headers: {
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );

    return res.data;
  }
);
//前回のレコードを取得（オリジナルメニュー）
export const fetchAsyncGetLastOriginalRecord = createAsyncThunk(
  "home/getLastOriginalRecord",
  async (para: GET_LAST_RECORD_PARAMETERS) => {
    const res = await axios.get<READ_RECORD_FULL>(
      `${process.env.REACT_APP_API_URL}/api-data/last_original_records/?id=${para.id}&menu_id=${para.menu_id}`,
      {
        headers: {
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );

    return res.data;
  }
);

//followList取得 (user_idを渡すと、該当ユーザーのフォローリストを取得)
export const fetchAsyncGetFollowList = createAsyncThunk(
  "home/followList",
  async (id: number) => {
    const res = await axios.get<FOLLOW_LIST_DATA>(
      `${process.env.REACT_APP_API_URL}/api-data/follow/?user_id=${id}`,
      {
        headers: {
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data;
  }
);
//selectUserFollowList用
export const fetchAsyncGetSelectFollowList = createAsyncThunk(
  "home/selectFollowList",
  async (id: number) => {
    const res = await axios.get<FOLLOW_LIST_DATA>(
      `${process.env.REACT_APP_API_URL}/api-data/follow/?user_id=${id}`,
      {
        headers: {
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data;
  }
);
//新規にフォロー(ProfileのIDを引数)
export const fetchAsyncNewFollow = createAsyncThunk(
  "home/newFollow",
  async (id: { follow_target_id: number }) => {
    const res = await axios.post<FOLLOW_LIST>(
      `${process.env.REACT_APP_API_URL}/api-data/follow/`,
      id,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data;
  }
);
//フォロー解除(followのIDを引数)
export const fetchAsyncDeleteFollow = createAsyncThunk(
  "home/deleteFollow",
  async (id: number) => {
    await axios.delete<FOLLOW_LIST>(
      `${process.env.REACT_APP_API_URL}/api-data/follow/${id}/`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return id;
  }
);
//timeレコードの取得
export const fetchAsyncGetTimeRecord = createAsyncThunk(
  "home/getTimeRecord",
  async (para: GET_DATE_RECORD_PARAMETERS) => {
    const res = await axios.get<TIME_RECORD_DATA>(
      `${process.env.REACT_APP_API_URL}/api-data/record_time/?date=${para.date}&id=${para.user_id}`,
      {
        headers: {
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    if (res.data.count === 0) {
      return initialState.timeRecord;
    } else {
      return res.data.results[0];
    }
  }
);
//対象ユーザのtimeレコードを削除
export const fetchAsyncDeleteTimeRecord = createAsyncThunk(
  "home/deleteTimeRecord",
  async (timePara: DELETE_TIME_RECORD_PARAMETERS) => {
    await axios.delete<number>(
      `${process.env.REACT_APP_API_URL}/api-data/record_time/${timePara.id}/?date=${timePara.date}&id=${timePara.user_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return timePara.id;
  }
);
//timeレコード新規作成
export const fetchAsyncCreateTimeRecord = createAsyncThunk(
  "home/createTimeRecord",
  async (record: POST_TIME_RECORD_PARAMETERS) => {
    const res = await axios.post<TIME_RECORD>(
      `${process.env.REACT_APP_API_URL}/api-data/record_time/`,
      record,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data;
  }
);
//timeレコード更新
export const fetchAsyncUpdateTimeRecord = createAsyncThunk(
  "home/updateTimeRecord",
  async (record: UPDATE_TIME_RECORD_PARAMETERS) => {
    const res = await axios.put<TIME_RECORD>(
      `${process.env.REACT_APP_API_URL}/api-data/record_time/${record.id}/?date=${record.date}&id=${record.user_id}`,
      record,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data;
  }
);
//Originalレコードの取得
export const fetchAsyncGetOriginalMenu = createAsyncThunk(
  "home/getOriginalMenu",
  async () => {
    const res = await axios.get<ORIGINAL_MENU_DATA>(
      `${process.env.REACT_APP_API_URL}/api-data/original_menu/`,
      {
        headers: {
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    if (res.data.count === 0) {
      return initialState.originalMenu;
    } else {
      return res.data.results;
    }
  }
);
//対象ユーザのOriginalレコードを削除
export const fetchAsyncDeleteOriginalMenu = createAsyncThunk(
  "home/deleteOriginalMenu",
  async (id: number) => {
    await axios.delete<number>(
      `${process.env.REACT_APP_API_URL}/api-data/original_menu/${id}/`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return id;
  }
);
//Originalレコード新規作成
export const fetchAsyncCreateOriginalMenu = createAsyncThunk(
  "home/createOriginalMenu",
  async (menu: ORIGINAL_MENU) => {
    const res = await axios.post<ORIGINAL_MENU>(
      `${process.env.REACT_APP_API_URL}/api-data/original_menu/`,
      menu,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data;
  }
);
//Originalレコード更新
export const fetchAsyncUpdateOriginalMenu = createAsyncThunk(
  "home/updateOriginalMenu",
  async (menu: ORIGINAL_MENU) => {
    const res = await axios.put<ORIGINAL_MENU>(
      `${process.env.REACT_APP_API_URL}/api-data/original_menu/${menu.id}/`,
      menu,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.localJWT}`,
        },
      }
    );
    return res.data;
  }
);

export const initialState: RECORD_STATE = {
  records: [
    {
      id: 0,
      menu_id: 0,
      menu_title: "",
      menu_part: "",
      menu_type: "",
      menu_color: "",
      weight: null,
      number_value: 0,
      set_value: null,
      date: "",
      user_id: 0,
      menu_user_id: "",
    },
  ],
  originalRecords: [
    {
      id: 0,
      menu_id: 0,
      menu_title: "",
      menu_part_number: "",
      menu_part: "",
      menu_type_number: "",
      menu_type: "",
      menu_color_number: "",
      menu_color: "",
      weight: null,
      number_value: 0,
      set_value: null,
      date: "",
      user_id: 0,
      menu_user_id: "",
    },
  ],
  dayRecords: [
    {
      id: 0,
      menu_id: 0,
      menu_title: "",
      menu_part: "",
      menu_type: "",
      menu_color: "",
      weight: null,
      number_value: 0,
      set_value: null,
      date: "",
      user_id: 0,
      menu_user_id: "",
    },
  ],
  dayOriginalRecords: [
    {
      id: 0,
      menu_id: 0,
      menu_title: "",
      menu_part_number: "",
      menu_part: "",
      menu_type_number: "",
      menu_type: "",
      menu_color_number: "",
      menu_color: "",
      weight: null,
      number_value: 0,
      set_value: null,
      date: "",
      user_id: 0,
      menu_user_id: "",
    },
  ],
  tempRecords: [
    {
      id: 0,
      menu_id: 0,
      menu_title: "",
      menu_part: "",
      menu_type: "",
      menu_color: "",
      weight: null,
      number_value: 0,
      set_value: null,
      date: "",
      user_id: 0,
      menu_user_id: "",
    },
  ],
  tempOriginalRecords: [
    {
      id: 0,
      menu_id: 0,
      menu_title: "",
      menu_part_number: "",
      menu_part: "",
      menu_type_number: "",
      menu_type: "",
      menu_color_number: "",
      menu_color: "",
      weight: null,
      number_value: 0,
      set_value: null,
      date: "",
      user_id: 0,
      menu_user_id: "",
    },
  ],
  editedRecord: [
    {
      id: 0,
      menu_id: 0,
      weight: null,
      number_value: 0,
      set_value: null,
      date: "",
    },
  ],
  selectedRecord: {
    id: 0,
    menu_id: 0,
    menu_title: "",
    menu_part: "",
    menu_type: "",
    menu_color: "",
    weight: null,
    number_value: 0,
    set_value: null,
    date: "",
    user_id: 0,
    menu_user_id: "",
  },
  lastRecord: {
    count: 0,
    next: null,
    previous: null,
    results: [
      {
        id: 0,
        menu_id: 0,
        menu_title: "",
        menu_part: "",
        menu_type: "",
        menu_color: "",
        weight: null,
        number_value: 0,
        set_value: null,
        date: "",
        user_id: 0,
        menu_user_id: "",
      },
    ],
  },
  users: [
    {
      user_profile: 0,
      username: "",
      img: "",
    },
  ],
  menu: [
    {
      id: 0,
      title: "",
      part: "",
      part_name: "",
      type: "",
      type_name: "",
      color: "",
      menu_color: "",
      user_id: 0,
    },
  ],
  originalMenu: [
    {
      id: 0,
      title: "",
      part: "",
      part_name: "",
      type: "",
      type_name: "",
      color: "",
      menu_color: "",
      user_id: 0,
    },
  ],
  editedOriginalMenu: {
    id: 0,
    title: "",
    part: "",
    part_name: "",
    type: "",
    type_name: "",
    color: "",
    menu_color: "",
    user_id: 0,
  },
  favoriteMenu: [
    {
      id: 0,
      menu_id: 0,
      menu_title: "",
      menu_part: "",
      menu_type: "",
      menu_color: "",
      user_id: 0,
      created_at: "",
      updated_at: "",
    },
  ],
  targetDay: "",
  selectedMenu: {
    id: 0,
    title: "",
    part: "",
    part_name: "",
    type: "",
    type_name: "",
    color: "",
    menu_color: "",
    user_id: 0,
  },
  selectedUser: {
    user_profile: 0,
    username: "",
  },
  searchCategory: {
    height: 0,
    weight: 0,
    gender: "",
    searchWord: "",
  },
  followList: {
    count: 0,
    next: null,
    previous: null,
    results: [
      {
        id: 0,
        user_id: 0,
        follow_target_id: 0,
        follow_target_username: "",
        follow_target_img: "",
        follow_target_user_profile: 0,
      },
    ],
  },
  selectUserFollowList: {
    count: 0,
    next: null,
    previous: null,
    results: [
      {
        id: 0,
        user_id: 0,
        follow_target_id: 0,
        follow_target_username: "",
        follow_target_img: "",
        follow_target_user_profile: 0,
      },
    ],
  },
  followAccount: false,
  timeRecord: {
    id: 0,
    user_id: 0,
    data: "",
    time_number: 0,
  },
  isQuickEditRecordFlg: false,
  selectedMenuCategory: {
    title: "",
    titleSub: "",
    part: "",
    part_name: "",
    url: "",
    width: "",
  },
};

export const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    //選択したrecordをeditedRecordへ格納するアクション
    editRecord(state, action: PayloadAction<POST_RECORD[]>) {
      state.editedRecord = action.payload;
    },
    editOriginalMenu(state, action: PayloadAction<ORIGINAL_MENU>) {
      state.editedOriginalMenu = action.payload;
    },
    //選択したrecordをselectedRecordへ格納するアクション
    selectRecord(state, action: PayloadAction<READ_RECORD>) {
      state.selectedRecord = action.payload;
    },
    selectMenuCategory(state, action: PayloadAction<SELECT_MENU_CATEGORY>) {
      state.selectedMenuCategory = action.payload;
    },
    addDayRecord(state, action: PayloadAction<READ_RECORD[]>) {
      state.dayRecords = action.payload;
    },
    addDayRecordReset(state) {
      state.dayRecords = initialState.dayRecords;
    },
    addDayOriginalRecord(state, action: PayloadAction<ORIGINAL_RECORD[]>) {
      state.dayOriginalRecords = action.payload;
    },
    selectTargetDay(state, action: PayloadAction<string>) {
      state.targetDay = action.payload;
    },
    selectTargetMenu(state, action: PayloadAction<MENU>) {
      state.selectedMenu = action.payload;
    },
    selectTargetUser(state, action: PayloadAction<SELECT_USER>) {
      state.selectedUser = action.payload;
    },
    setSearchCategory(state, action: PayloadAction<SEARCH_DATA>) {
      state.searchCategory = action.payload;
    },
    setFollowAccount(state, action: PayloadAction<boolean>) {
      state.followAccount = action.payload;
    },
    clearSelectFollowList(state) {
      state.selectUserFollowList = initialState.selectUserFollowList;
    },
    addIsQuickEditRecordFlg(state, action: PayloadAction<boolean>) {
      state.isQuickEditRecordFlg = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchAsyncGetRecords.fulfilled,
      (state, action: PayloadAction<READ_RECORD[]>) => {
        return {
          ...state,
          records: action.payload,
        };
      }
    );
    builder.addCase(fetchAsyncGetRecords.rejected, () => {
      window.location.href = "/login";
    });
    builder.addCase(
      fetchAsyncGetOriginalRecords.fulfilled,
      (state, action: PayloadAction<ORIGINAL_RECORD[]>) => {
        return {
          ...state,
          originalRecords: action.payload,
        };
      }
    );
    builder.addCase(fetchAsyncGetOriginalRecords.rejected, () => {
      window.location.href = "/login";
    });
    builder.addCase(
      fetchAsyncGetLastRecord.fulfilled,
      (state, action: PayloadAction<READ_RECORD_FULL>) => {
        return {
          ...state,
          lastRecord: action.payload,
        };
      }
    );
    builder.addCase(
      fetchAsyncGetLastOriginalRecord.fulfilled,
      (state, action: PayloadAction<READ_RECORD_FULL>) => {
        return {
          ...state,
          lastRecord: action.payload,
        };
      }
    );
    builder.addCase(
      fetchAsyncGetTempRecords.fulfilled,
      (state, action: PayloadAction<READ_RECORD[]>) => {
        return {
          ...state,
          tempRecords: action.payload,
        };
      }
    );
    builder.addCase(fetchAsyncGetTempRecords.rejected, () => {
      window.location.href = "/login";
    });
    builder.addCase(
      fetchAsyncGetTempOriginalRecords.fulfilled,
      (state, action: PayloadAction<ORIGINAL_RECORD[]>) => {
        return {
          ...state,
          tempOriginalRecords: action.payload,
        };
      }
    );
    builder.addCase(fetchAsyncGetTempOriginalRecords.rejected, () => {
      window.location.href = "/login";
    });
    builder.addCase(
      fetchAsyncGetUsers.fulfilled,
      (state, action: PayloadAction<USER[]>) => {
        return {
          ...state,
          users: action.payload,
        };
      }
    );
    builder.addCase(
      fetchAsyncGetMenu.fulfilled,
      (state, action: PayloadAction<MENU[]>) => {
        return {
          ...state,
          menu: action.payload,
        };
      }
    );
    builder.addCase(
      fetchAsyncGetTargetMenu.fulfilled,
      (state, action: PayloadAction<MENU>) => {
        return {
          ...state,
          selectedMenu: action.payload,
        };
      }
    );
    builder.addCase(
      fetchAsyncGetTargetOriginalMenu.fulfilled,
      (state, action: PayloadAction<MENU>) => {
        return {
          ...state,
          selectedMenu: action.payload,
        };
      }
    );
    builder.addCase(
      fetchAsyncGetFavoriteMenu.fulfilled,
      (state, action: PayloadAction<FAVORITE_MENU[]>) => {
        return {
          ...state,
          favoriteMenu: action.payload,
        };
      }
    );
    builder.addCase(
      fetchAsyncCreateFavoriteMenu.fulfilled,
      (state, action: PayloadAction<FAVORITE_MENU>) => {
        return {
          ...state,
          favoriteMenu: [action.payload, ...state.favoriteMenu],
        };
      }
    );
    builder.addCase(
      //follow解除したユーザをstateに反映
      fetchAsyncDeleteFavoriteMenu.fulfilled,
      (state, action: PayloadAction<number>) => {
        return {
          ...state,
          favoriteMenu: state.favoriteMenu.filter(
            (r) => r.id !== action.payload
          ),
        };
      }
    );
    builder.addCase(
      fetchAsyncCreateTempRecord.fulfilled,
      (state, action: PayloadAction<READ_RECORD>) => {
        return {
          ...state,
          tempRecords: [action.payload, ...state.tempRecords],
          editedRecord: initialState.editedRecord,
        };
      }
    );
    builder.addCase(fetchAsyncCreateTempRecord.rejected, () => {
      window.location.href = "/login";
    });
    builder.addCase(
      fetchAsyncCreateTempOriginalRecord.fulfilled,
      (state, action: PayloadAction<ORIGINAL_RECORD>) => {
        return {
          ...state,
          tempOriginalRecords: [action.payload, ...state.tempOriginalRecords],
          // editedRecord: initialState.editedRecord,
        };
      }
    );
    builder.addCase(fetchAsyncCreateTempOriginalRecord.rejected, () => {
      window.location.href = "/login";
    });
    builder.addCase(
      fetchAsyncUpdateTempRecord.fulfilled,
      (state, action: PayloadAction<READ_RECORD>) => {
        return {
          ...state,
          tempRecords: state.tempRecords.map((r) =>
            r.id === action.payload.id ? action.payload : r
          ),
          editedRecord: initialState.editedRecord,
          selectedRecord: initialState.selectedRecord,
        };
      }
    );
    builder.addCase(fetchAsyncUpdateTempRecord.rejected, () => {
      window.location.href = "/login";
    });
    builder.addCase(
      fetchAsyncUpdateTempOriginalRecord.fulfilled,
      (state, action: PayloadAction<ORIGINAL_RECORD>) => {
        return {
          ...state,
          tempOriginalRecords: state.tempOriginalRecords.map((r) =>
            r.id === action.payload.id ? action.payload : r
          ),
          editedRecord: initialState.editedRecord,
          selectedRecord: initialState.selectedRecord,
        };
      }
    );
    builder.addCase(fetchAsyncUpdateTempOriginalRecord.rejected, () => {
      window.location.href = "/login";
    });
    builder.addCase(
      fetchAsyncDeleteTempRecord.fulfilled,
      (state, action: PayloadAction<number>) => {
        return {
          ...state,
          tempRecords: state.tempRecords.filter((r) => r.id !== action.payload),
          editedRecord: initialState.editedRecord,
          selectedRecord: initialState.selectedRecord,
        };
      }
    );
    builder.addCase(fetchAsyncDeleteTempRecord.rejected, () => {
      window.location.href = "/login";
    });
    builder.addCase(
      fetchAsyncDeleteTempOriginalRecord.fulfilled,
      (state, action: PayloadAction<number>) => {
        return {
          ...state,
          tempOriginalRecords: state.tempOriginalRecords.filter(
            (r) => r.id !== action.payload
          ),
          editedRecord: initialState.editedRecord,
          selectedRecord: initialState.selectedRecord,
        };
      }
    );
    builder.addCase(fetchAsyncDeleteTempOriginalRecord.rejected, () => {
      window.location.href = "/login";
    });

    builder.addCase(
      fetchAsyncGetTimeRecord.fulfilled,
      (state, action: PayloadAction<TIME_RECORD>) => {
        return {
          ...state,
          timeRecord: action.payload,
        };
      }
    );
    builder.addCase(fetchAsyncGetTimeRecord.rejected, () => {
      window.location.href = "/login";
    });
    builder.addCase(
      fetchAsyncCreateTimeRecord.fulfilled,
      (state, action: PayloadAction<TIME_RECORD>) => {
        return {
          ...state,
          timeRecord: action.payload,
        };
      }
    );
    builder.addCase(fetchAsyncCreateTimeRecord.rejected, () => {
      window.location.href = "/login";
    });
    builder.addCase(
      fetchAsyncUpdateTimeRecord.fulfilled,
      (state, action: PayloadAction<TIME_RECORD>) => {
        return {
          ...state,
          timeRecord: action.payload,
        };
      }
    );
    builder.addCase(fetchAsyncUpdateTimeRecord.rejected, () => {
      window.location.href = "/login";
    });
    builder.addCase(
      fetchAsyncDeleteTimeRecord.fulfilled,
      (state, action: PayloadAction<number>) => {
        return {
          ...state,
          timeRecords: initialState.timeRecord,
        };
      }
    );
    builder.addCase(fetchAsyncDeleteTimeRecord.rejected, () => {
      window.location.href = "/login";
    });

    builder.addCase(
      fetchAsyncGetOriginalMenu.fulfilled,
      (state, action: PayloadAction<ORIGINAL_MENU[]>) => {
        return {
          ...state,
          originalMenu: action.payload,
        };
      }
    );
    builder.addCase(fetchAsyncGetOriginalMenu.rejected, () => {
      window.location.href = "/login";
    });
    builder.addCase(
      fetchAsyncCreateOriginalMenu.fulfilled,
      (state, action: PayloadAction<ORIGINAL_MENU>) => {
        return {
          ...state,
          originalMenu: [...state.originalMenu, action.payload],
        };
      }
    );
    builder.addCase(fetchAsyncCreateOriginalMenu.rejected, () => {
      window.location.href = "/login";
    });
    builder.addCase(
      fetchAsyncUpdateOriginalMenu.fulfilled,
      (state, action: PayloadAction<ORIGINAL_MENU>) => {
        return {
          ...state,
          originalMenu: state.originalMenu.map((r) =>
            r.id === action.payload.id ? action.payload : r
          ),
          editedOriginalMenu: initialState.editedOriginalMenu,
        };
      }
    );
    builder.addCase(fetchAsyncUpdateOriginalMenu.rejected, () => {
      window.location.href = "/login";
    });
    builder.addCase(
      fetchAsyncDeleteOriginalMenu.fulfilled,
      (state, action: PayloadAction<number>) => {
        return {
          ...state,
          originalMenu: state.originalMenu.filter(
            (r) => r.id !== action.payload
          ),
        };
      }
    );
    builder.addCase(fetchAsyncDeleteOriginalMenu.rejected, () => {
      window.location.href = "/login";
    });

    builder.addCase(
      fetchAsyncCreateRecord.fulfilled,
      (state, action: PayloadAction<READ_RECORD>) => {
        return {
          ...state,
          records: [action.payload, ...state.records],
          editedRecord: initialState.editedRecord,
        };
      }
    );
    builder.addCase(fetchAsyncCreateRecord.rejected, () => {
      window.location.href = "/login";
    });
    builder.addCase(
      fetchAsyncCreateOriginalRecord.fulfilled,
      (state, action: PayloadAction<ORIGINAL_RECORD>) => {
        return {
          ...state,
          originalRecords: [action.payload, ...state.originalRecords],
          editedRecord: initialState.editedRecord,
        };
      }
    );
    builder.addCase(fetchAsyncCreateOriginalRecord.rejected, () => {
      window.location.href = "/login";
    });
    builder.addCase(
      fetchAsyncUpdateRecord.fulfilled,
      (state, action: PayloadAction<READ_RECORD>) => {
        return {
          ...state,
          records: state.records.map((r) =>
            r.id === action.payload.id ? action.payload : r
          ),
          dayRecords: state.dayRecords.map((r) =>
            r.id === action.payload.id ? action.payload : r
          ),
          editedRecord: initialState.editedRecord,
          selectedRecord: initialState.selectedRecord,
        };
      }
    );
    builder.addCase(fetchAsyncUpdateRecord.rejected, () => {
      window.location.href = "/login";
    });
    builder.addCase(
      fetchAsyncUpdateOriginalRecord.fulfilled,
      (state, action: PayloadAction<ORIGINAL_RECORD>) => {
        return {
          ...state,
          originalRecords: state.originalRecords.map((r) =>
            r.id === action.payload.id ? action.payload : r
          ),
          dayOriginalRecords: state.dayOriginalRecords.map((r) =>
            r.id === action.payload.id ? action.payload : r
          ),
          editedRecord: initialState.editedRecord,
          selectedRecord: initialState.selectedRecord,
        };
      }
    );
    builder.addCase(fetchAsyncUpdateOriginalRecord.rejected, () => {
      window.location.href = "/login";
    });
    builder.addCase(
      fetchAsyncDeleteRecord.fulfilled,
      (state, action: PayloadAction<number>) => {
        return {
          ...state,
          records: state.records.filter((r) => r.id !== action.payload),
          dayRecords: state.dayRecords.filter((r) => r.id !== action.payload),
          editedRecord: initialState.editedRecord,
          selectedRecord: initialState.selectedRecord,
        };
      }
    );
    builder.addCase(fetchAsyncDeleteRecord.rejected, () => {
      window.location.href = "/login";
    });
    builder.addCase(
      fetchAsyncDeleteOriginalRecord.fulfilled,
      (state, action: PayloadAction<number>) => {
        return {
          ...state,
          originalRecords: state.originalRecords.filter(
            (r) => r.id !== action.payload
          ),
          dayOriginalRecords: state.dayOriginalRecords.filter(
            (r) => r.id !== action.payload
          ),
          editedRecord: initialState.editedRecord,
          selectedRecord: initialState.selectedRecord,
        };
      }
    );
    builder.addCase(fetchAsyncDeleteOriginalRecord.rejected, () => {
      window.location.href = "/login";
    });
    builder.addCase(
      //followリストを取得し、stateに保存
      fetchAsyncGetFollowList.fulfilled,
      (state, action: PayloadAction<FOLLOW_LIST_DATA>) => {
        return {
          ...state,
          followList: action.payload,
        };
      }
    );
    builder.addCase(fetchAsyncGetFollowList.rejected, () => {
      //取得できない場合は、JWTが切れている場合
      window.location.href = "/login";
    });
    builder.addCase(
      //followリストを取得し、stateに保存
      fetchAsyncGetSelectFollowList.fulfilled,
      (state, action: PayloadAction<FOLLOW_LIST_DATA>) => {
        return {
          ...state,
          selectUserFollowList: action.payload,
        };
      }
    );
    builder.addCase(fetchAsyncGetSelectFollowList.rejected, () => {
      //取得できない場合は、JWTが切れている場合
      window.location.href = "/login";
    });
    builder.addCase(
      //newFollowをstateに追加
      fetchAsyncNewFollow.fulfilled,
      (state, action: PayloadAction<FOLLOW_LIST>) => {
        return {
          ...state,
          followList: {
            ...state.followList,
            count: state.followList.count + 1,
            results: [...state.followList.results, action.payload],
          },
        };
      }
    );
    builder.addCase(fetchAsyncNewFollow.rejected, () => {
      //取得できない場合は、JWTが切れている場合
      window.location.href = "/login";
    });
    builder.addCase(
      //follow解除したユーザをstateに反映
      fetchAsyncDeleteFollow.fulfilled,
      (state, action: PayloadAction<number>) => {
        return {
          ...state,
          followList: {
            ...state.followList,
            count: state.followList.count - 1,
            results: state.followList.results.filter(
              (r) => r.id !== action.payload
            ),
          },
        };
      }
    );
    builder.addCase(fetchAsyncDeleteFollow.rejected, () => {
      //取得できない場合は、JWTが切れている場合
      window.location.href = "/login";
    });
  },
});

export const {
  editRecord,
  editOriginalMenu,
  selectRecord,
  addDayRecord,
  addDayRecordReset,
  selectTargetDay,
  selectTargetMenu,
  selectTargetUser,
  setSearchCategory,
  setFollowAccount,
  clearSelectFollowList,
  addIsQuickEditRecordFlg,
  addDayOriginalRecord,
  selectMenuCategory,
} = homeSlice.actions;
export const selectRecords = (state: RootState) => state.home.records;
export const selectOriginalRecords = (state: RootState) =>
  state.home.originalRecords;
export const selectDayRecords = (state: RootState) => state.home.dayRecords;
export const selectTempRecords = (state: RootState) => state.home.tempRecords;
export const selectUsers = (state: RootState) => state.home.users;
export const selectMenu = (state: RootState) => state.home.menu;
export const selectFavoriteMenu = (state: RootState) => state.home.favoriteMenu;
export const selectSelectTargetDay = (state: RootState) => state.home.targetDay;
export const selectEditedRecord = (state: RootState) => state.home.editedRecord;
export const selectSelectedRecord = (state: RootState) =>
  state.home.selectedRecord;
export const selectLastRecord = (state: RootState) => state.home.lastRecord;
export const selectSelectedMenu = (state: RootState) => state.home.selectedMenu;
export const selectSelectedUser = (state: RootState) => state.home.selectedUser;
export const selectSearchCategory = (state: RootState) =>
  state.home.searchCategory;
export const selectFollowList = (state: RootState) => state.home.followList;
export const selectSelectUserFollowList = (state: RootState) =>
  state.home.selectUserFollowList;
export const selectFollowAccount = (state: RootState) =>
  state.home.followAccount;
export const selectTimeRecord = (state: RootState) => state.home.timeRecord;
export const selectIsQuickEditRecordFlg = (state: RootState) =>
  state.home.isQuickEditRecordFlg;
export const selectOriginalMenu = (state: RootState) => state.home.originalMenu;
export const selectEditedOriginalMenu = (state: RootState) =>
  state.home.editedOriginalMenu;
export const selectTempOriginalRecords = (state: RootState) =>
  state.home.tempOriginalRecords;
export const selecDayOriginalRecords = (state: RootState) =>
  state.home.dayOriginalRecords;
export const selectSelectedMenuCategory = (state: RootState) =>
  state.home.selectedMenuCategory;

export default homeSlice.reducer;
